export const SAVE_RECORDING_METADATA = 'SAVE_RECORDING_METADATA';
export const SAVE_RECORDING_METADATA_SUCCESS =
  'SAVE_RECORDING_METADATA_SUCCESS';
export const SAVE_RECORDING_METADATA_FAILURE =
  'SAVE_RECORDING_METADATA_FAILURE';

// export const GET_ALL_RECORDINGS = 'GET_ALL_RECORDINGS';
// export const GET_ALL_RECORDINGS_SUCCESS = 'GET_ALL_RECORDINGS_SUCCESS';
// export const GET_ALL_RECORDINGS_ERROR = 'GET_ALL_RECORDINGS_SUCCESS';
